import React from "react";
import styled from "styled-components";
import { Content } from "../Content";
import { primaryGradient, secondaryGradient } from "../GradientBox";
import { mobileQuery } from "../MediaQuery";

export const Section: React.FC<{
  primaryGradient?: boolean;
  secondaryGradient?: boolean;
  children?: React.ReactNode;
}> = (props) => (
  <Wrapper
    gradient={
      props.primaryGradient
        ? primaryGradient
        : props.secondaryGradient
        ? secondaryGradient
        : undefined
    }
  >
    <Content>{props.children}</Content>
  </Wrapper>
);

const Wrapper = styled.div<{ gradient?: string }>`
  ${(props) =>
    props.gradient &&
    `
    background: ${props.gradient};
  `}
  padding: 50px 0;

  ${mobileQuery`
    padding: 34px 0;
  `}
`;
